export default __webpack_public_path__ + "static/media/lib-12.9b5e71af.webp";